<template>
    <Breadcrumbs main="Maps" title="Google Maps" />
    <div class="container-fluid">
        <div class="row">

            <Card9 colClass="col-lg-6 " cardhaderClass="pb-0 title-header" title="Map at a specified location" span="true"
                :spanClass="desc">
                <GoogleMap :center="{ lat: 20.5937, lng: 78.9629 }" :zoom="12" style="width: auto; height: 500px">
                </GoogleMap>
            </Card9>


            <Card9 colClass="col-lg-6 " cardhaderClass="pb-0 title-header" title="Multi-language support" span="true"
                :spanClass="desc1">
                <GoogleMap :center="{ lat: 20.5937, lng: 78.9629 }" :zoom="6" style="width: auto; height: 500px" :options="{
                    region: 'VI',
                    language: 'vi',
                }">
                </GoogleMap>
            </Card9>

            <Card9 colClass="col-lg-6 " cardhaderClass="pb-0 title-header" title="Marker on the Map" span="true" :spanClass="desc2">
                <Markers></Markers>
            </Card9>


            <Card9 colClass="col-lg-6 " cardhaderClass="pb-0 title-header" title="Draggable Marker" span="true" :spanClass="desc3">
                <DraggableMarker></DraggableMarker>
            </Card9>


            <Card9 colClass="col-lg-6 " cardhaderClass="pb-0 title-header" title="Polyline on the Map" span="true" :spanClass="desc4">
                <GooglePolyline></GooglePolyline>
            </Card9>


            <Card9 colClass="col-lg-6 " cardhaderClass="pb-0 title-header" title="Polygon on the Map" span="true" :spanClass="desc5">
                <TrianglePolygon></TrianglePolygon>
            </Card9>

        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
import { GoogleMap, } from "vue3-google-map";
const Card9 = defineAsyncComponent(() => import("@/components/commen/card/cardData9.vue"))
const Markers = defineAsyncComponent(() => import("@/components/theme/maps/markersMap.vue"))
const DraggableMarker = defineAsyncComponent(() => import("@/components/theme/maps/draggableMarker.vue"))
const GooglePolyline = defineAsyncComponent(() => import("@/components/theme/maps/googlePolyline.vue"))
const TrianglePolygon = defineAsyncComponent(() => import("@/components/theme/maps/trianglePolygon.vue"))
let desc = "Display a map at a specified location and zoom level."
let desc1 = "Display a map with labels in a foreign language"
let desc2 = "Display a map highlighting points of interest"
let desc3 = "Display a map highlighting points of interest"
let desc4 = "Display a map with a line showing a known route"
let desc5 = "Display a map highlighting a region or area"
</script>